export default __webpack_public_path__ + "static/media/UG.e4f1b124.svg";